export function hashLocalizationKey(str: string): string {
  if (str.length === 0) {
    return "0";
  }

  // if this key has been hashed by some other script, keep as is
  // it should have a "#" as first character
  if (str[0] === "#") {
    return str;
  }

  let hash = 0;
  for (let i = 0; i < str.length; ++i) {
    const c = str.charCodeAt(i);

    hash = ((hash << 5) - hash + c) | 0;
  }
  // add "#" so we can recognize hashed keys
  return "#" + hash.toString(36);
}
